import React from 'react';
import { useTranslation } from 'react-i18next';
import { getCircleButtonClass } from '../../v2/buttons/CircleButton';
import HomeIcon from '../../v2/icons/HomeIcon';
import UserIcon from '../../v2/icons/UserIcon';
import PhoneIcon from '../../v2/icons/PhoneIcon';
import EmailIcon from '../../v2/icons/EmailIcon';
import LockIcon from '../../v2/icons/LockIcon';
import CogIcon from '../../v2/icons/CogIcon';
import LocationMarkerIcon from '../../v2/icons/LocationMarkerIcon';
import DollarIcon from '../../v2/icons/DollarIcon';
import TrendingUpIcon from '../../v2/icons/TrendingUpIcon';
function getIcon(iconName) {
    switch (iconName) {
        case 'home':
            return React.createElement(HomeIcon, null);
        case 'user':
            return React.createElement(UserIcon, null);
        case 'phone':
            return React.createElement(PhoneIcon, null);
        case 'email':
        case 'envelope':
        case 'mail':
            return React.createElement(EmailIcon, null);
        case 'location-marker':
        case 'map-marker':
            return React.createElement(LocationMarkerIcon, null);
        case 'usd':
        case 'dollar':
            return React.createElement(DollarIcon, { size: "medium" });
        case 'trending-up':
            return React.createElement(TrendingUpIcon, null);
        case 'lock':
            return React.createElement(LockIcon, null);
        case 'billing_rep':
            return React.createElement(DollarIcon, { size: "medium" });
        case 'operations_manager':
            return React.createElement(CogIcon, null);
        case 'account_manager':
            return React.createElement(UserIcon, null);
        default:
            return null;
    }
}
const LabelValue = (props) => {
    const isNull = !props.value || props.value === 'null' || props.value === 'undefined';
    const { t } = useTranslation();
    let value;
    const { children } = props;
    if (children) {
        value = children;
    }
    else {
        value = isNull ? t('NOT_SET') : props.value;
    }
    return (React.createElement("div", { className: "flex items-center mb-2 -mx-2" },
        React.createElement("div", { className: "px-2 min-w-1/6" },
            props.sequence && (React.createElement("div", { className: getCircleButtonClass({ color: 'gray', size: 'small' }) },
                React.createElement("span", { className: "text-gray-700" }, props.sequence))),
            props.icon && (React.createElement("div", { className: getCircleButtonClass({ color: 'gray', size: 'small' }) }, getIcon(props.icon))),
            !props.glyph && props.label && (React.createElement("label", { className: "my-0 form-label" },
                "$",
                props.label))),
        React.createElement("div", { className: "px-2 break-words overflow-hidden" },
            React.createElement("span", { className: "break-words text-grey-dark" }, value))));
};
export default LabelValue;
